import { Injectable } from '@angular/core';
import { DynamicScriptLoaderService } from './dynamicScriptLoaderService';
import { CommonService } from './app.common.service';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {
  constructor(public dynamicScripts: DynamicScriptLoaderService, private common: CommonService, public datepipe: DatePipe,) { }


  public exportToExcel(records: any, listingFields: any, systemPage: any): void {
    let listData = records;
    let pageFields = listingFields;
    let fileName = this.common.normalizedFileName(this.common.getDocumentTitle()) + "_" + this.common.formatDate(Date.now(), "dddd, MMMM Do YYYY, HH:mm:ss");
    if (systemPage && !this.common.isNullOrWhiteSpace(systemPage.pageTitle))
      fileName = this.common.normalizedFileName(systemPage.pageTitle) + "_" + this.common.formatDate(Date.now(), "dddd, MMMM Do YYYY, HH:mm:ss");
    fileName += ".xlsx";
    let properties = Object.getOwnPropertyNames(records[0]);
    for (var f in pageFields) {
      var pageField = pageFields[f];
      let propertyName = pageField.columnName;
      //this is done to avoid javascript case sensitivity issue
      if (propertyName != null && properties != null) {
        propertyName = properties.filter(function (prop) {
          return prop != null && prop.toLowerCase() == propertyName.toLowerCase()
        })[0];
        pageField["normalizedColumnName"] = propertyName;
      }
    }


    let exportRecords: any[] = [];
    var sn = 1;
    for (var d in listData) {
      let data = listData[d];

      let exportData: any = { "#": sn };
      for (var f in pageFields) {
        let pageField = pageFields[f];

        let normalizedColumnName = pageField.normalizedColumnName;
        let columnName = pageField.columnName;
        let value = data[normalizedColumnName];

          if (pageField.columnType != null && pageField.columnType.toLowerCase() == 'date') {
            if (!this.common.isNullOrWhiteSpace(value))
              value = this.common.formatDate(value);

          }
          else if (pageField.columnType != null && pageField.columnType.toLowerCase() == 'datetime') {
            try {
              if (!this.common.isNullOrWhiteSpace(value))
                value = this.common.formatDate(value,"", true);
            } catch (e) { }
          } else if (pageField.columnType != null && pageField.columnType.toLowerCase() == 'time') {
            try {
              value = this.datepipe.transform(value, 'HH:mm');
            } catch (e) { }
          }

        exportData[pageField.columnHeader] = value;
      }
      exportRecords.push(exportData);
      sn++;
    }
    this.exportAsExcelFile(exportRecords, fileName)
  }



  public async exportAsExcelFile(json: any[], excelFileName: string): Promise<void> {
    this.common.Loader.show();
    try {
      const XLSX = await import('xlsx');
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(json);
      XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
      XLSX.writeFile(workBook, excelFileName); // initiate a file download in browser
    } catch (error) {
      console.error('Error exporting excel file:', error);
    } finally {
      this.common.Loader.hide();
    }
  }

  public readExcelFile(file: File): Promise<any[]> {
    return new Promise<any[]>(async (resolve, reject) => {
      try {
        const XLSX = await import('xlsx');
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
          try {
            const bstr: string = e.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            const wsname: string = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws, { header: 0 });
            resolve(data);
          } catch (err) {
            reject(err);
          }
        };
        reader.onerror = (error) => reject(error);
        reader.readAsBinaryString(file);
      } catch (err) {
        reject(err);
      }
    });
  }



}
